var map = {
	"./adventneDelavnice2015.jpg": 4848,
	"./ana.jpg": 3068,
	"./ana/male/cerkev-avtor-Matjaz-Sedusak.jpg": 8941,
	"./ana/male/cerkev-notranjost1-avtor-Damjan-Prelovsek.jpg": 2184,
	"./ana/male/cerkev-notranjost2-avtor-Damjan-Prelovsek.jpg": 4621,
	"./ana/male/cerkev-sv.-ane-tunjice-117-avtor-Matjaz-Sedusak.jpg": 3151,
	"./ana/male/cerkev-sv.-ane-tunjice-33-avtor-Matjaz-Sedusak.jpg": 6648,
	"./ana/male/cerkev-sv.-ane-tunjice-69-avtor-Matjaz-Sedusak.jpg": 1907,
	"./ana/male/cerkev-sv.-ane-tunjice-74-avtor-Matjaz-Sedusak.jpg": 1421,
	"./ana/male/cerkev-sv.-ane-tunjice-76-avtor-Matjaz-Sedusak.jpg": 5479,
	"./ana/male/cerkev-sv.-ane-tunjice-8-avtor-Matjaz-Sedusak.jpg": 8272,
	"./ana/male/internet-14-avtor-Matjaz-Sedusak.jpg": 8168,
	"./ana/male/internet-16-avtor-Matjaz-Sedusak.jpg": 6358,
	"./ana/male/internet-17-avtor-Matjaz-Sedusak.jpg": 405,
	"./ana/male/internet-19-avtor-Matjaz-Sedusak.jpg": 4731,
	"./ana/male/internet-3-avtor-Matjaz-Sedusak.jpg": 8676,
	"./ana/male/internet-4-avtor-Matjaz-Sedusak.jpg": 9405,
	"./ana/male/internet-8-avtor-Matjaz-Sedusak.jpg": 9193,
	"./ana/male/internet-9-avtor-Matjaz-Sedusak.jpg": 298,
	"./ana/male/pomlad-50-avtor-Matjaz-Sedusak.jpg": 2980,
	"./ana/male/sv.ana-10-avtor-Matjaz-Sedusak.jpg": 7768,
	"./ana/male/sv.ana-13-avtor-Matjaz-Sedusak.jpg": 7429,
	"./ana/male/zMAG2577-avtor-Darja-Mikus.jpg": 9457,
	"./ana/male/zMAG2589-avtor-Darja-Mikus.jpg": 7066,
	"./ana/male/zMAG2595-avtor-Darja-Mikus.jpg": 9277,
	"./ana/male/zMAG2597-avtor-Darja-Mikus.jpg": 6523,
	"./ana/male/zMAG2608-avtor-Darja-Mikus.jpg": 3236,
	"./ana/male/zMAG2611-avtor-Darja-Mikus.jpg": 3746,
	"./ana/male/zMAG2612-avtor-Darja-Mikus.jpg": 4377,
	"./ana/male/zMAG2616-avtor-Darja-Mikus.jpg": 3037,
	"./ana/male/zMAG2620-avtor-Darja-Mikus.jpg": 4410,
	"./ana/male/zMAG2639-avtor-Darja-Mikus.jpg": 2224,
	"./ana/male/zMAG2641-avtor-Darja-Mikus.jpg": 1525,
	"./ana/velike/cerkev-notranjost1.jpg": 8336,
	"./ana/velike/cerkev-notranjost2.jpg": 1327,
	"./ana/velike/cerkev-sv.-ane-tunjice-117.jpg": 1854,
	"./ana/velike/cerkev-sv.-ane-tunjice-33.jpg": 5969,
	"./ana/velike/cerkev-sv.-ane-tunjice-69.jpg": 940,
	"./ana/velike/cerkev-sv.-ane-tunjice-74.jpg": 4974,
	"./ana/velike/cerkev-sv.-ane-tunjice-76.jpg": 1036,
	"./ana/velike/cerkev-sv.-ane-tunjice-8.jpg": 6955,
	"./ana/velike/cerkev.jpg": 444,
	"./ana/velike/internet-14.jpg": 3697,
	"./ana/velike/internet-16.jpg": 7283,
	"./ana/velike/internet-17.jpg": 4118,
	"./ana/velike/internet-19.jpg": 9144,
	"./ana/velike/internet-3.jpg": 7427,
	"./ana/velike/internet-4.jpg": 6496,
	"./ana/velike/internet-8.jpg": 9164,
	"./ana/velike/internet-9.jpg": 4537,
	"./ana/velike/pomlad-50.jpg": 8881,
	"./ana/velike/sv.ana-10.jpg": 5761,
	"./ana/velike/sv.ana-13.jpg": 8006,
	"./ana/velike/zMAG2577.jpg": 7902,
	"./ana/velike/zMAG2589.jpg": 3781,
	"./ana/velike/zMAG2595.jpg": 3830,
	"./ana/velike/zMAG2597.jpg": 6020,
	"./ana/velike/zMAG2608.jpg": 7175,
	"./ana/velike/zMAG2611.jpg": 9565,
	"./ana/velike/zMAG2612.jpg": 9666,
	"./ana/velike/zMAG2616.jpg": 8102,
	"./ana/velike/zMAG2620.jpg": 4369,
	"./ana/velike/zMAG2639.jpg": 687,
	"./ana/velike/zMAG2641.jpg": 5358,
	"./dogodki.jpg": 7141,
	"./dogodki/adventneDelavnice2015/male/IMG-0003.jpg": 2744,
	"./dogodki/adventneDelavnice2015/male/IMG-0015.jpg": 5353,
	"./dogodki/adventneDelavnice2015/male/IMG-0016.jpg": 2862,
	"./dogodki/adventneDelavnice2015/male/IMG-0017.jpg": 9323,
	"./dogodki/adventneDelavnice2015/male/IMG-0019.jpg": 7869,
	"./dogodki/adventneDelavnice2015/male/IMG-0020.jpg": 2441,
	"./dogodki/adventneDelavnice2015/male/IMG-0021.jpg": 4396,
	"./dogodki/adventneDelavnice2015/male/IMG-0023.jpg": 9358,
	"./dogodki/adventneDelavnice2015/male/IMG-0024.jpg": 4357,
	"./dogodki/adventneDelavnice2015/male/IMG-0025.jpg": 840,
	"./dogodki/adventneDelavnice2015/male/IMG-0026.jpg": 5591,
	"./dogodki/adventneDelavnice2015/male/IMG-0027.jpg": 1754,
	"./dogodki/adventneDelavnice2015/male/IMG-0028.jpg": 9217,
	"./dogodki/adventneDelavnice2015/male/IMG-0029.jpg": 1172,
	"./dogodki/adventneDelavnice2015/male/IMG-0033.jpg": 9741,
	"./dogodki/adventneDelavnice2015/male/IMG-0039.jpg": 743,
	"./dogodki/adventneDelavnice2015/male/IMG-0040.jpg": 2019,
	"./dogodki/adventneDelavnice2015/male/IMG-0041.jpg": 3494,
	"./dogodki/adventneDelavnice2015/male/IMG-0043.jpg": 7540,
	"./dogodki/adventneDelavnice2015/male/IMG-0044.jpg": 8351,
	"./dogodki/adventneDelavnice2015/male/IMG-0045.jpg": 2034,
	"./dogodki/adventneDelavnice2015/male/IMG-0054.jpg": 8176,
	"./dogodki/adventneDelavnice2015/male/IMG-0055.jpg": 7405,
	"./dogodki/adventneDelavnice2015/male/IMG-0056.jpg": 7506,
	"./dogodki/adventneDelavnice2015/male/IMG-0057.jpg": 1791,
	"./dogodki/adventneDelavnice2015/male/IMG-0060.jpg": 7349,
	"./dogodki/adventneDelavnice2015/male/IMG-0062.jpg": 6935,
	"./dogodki/adventneDelavnice2015/male/IMG-0067.jpg": 4878,
	"./dogodki/adventneDelavnice2015/velike/IMG-0003.jpg": 5643,
	"./dogodki/adventneDelavnice2015/velike/IMG-0015.jpg": 6874,
	"./dogodki/adventneDelavnice2015/velike/IMG-0016.jpg": 8949,
	"./dogodki/adventneDelavnice2015/velike/IMG-0017.jpg": 4632,
	"./dogodki/adventneDelavnice2015/velike/IMG-0019.jpg": 2134,
	"./dogodki/adventneDelavnice2015/velike/IMG-0020.jpg": 9206,
	"./dogodki/adventneDelavnice2015/velike/IMG-0021.jpg": 8691,
	"./dogodki/adventneDelavnice2015/velike/IMG-0023.jpg": 6961,
	"./dogodki/adventneDelavnice2015/velike/IMG-0024.jpg": 8706,
	"./dogodki/adventneDelavnice2015/velike/IMG-0025.jpg": 415,
	"./dogodki/adventneDelavnice2015/velike/IMG-0026.jpg": 6064,
	"./dogodki/adventneDelavnice2015/velike/IMG-0027.jpg": 4637,
	"./dogodki/adventneDelavnice2015/velike/IMG-0028.jpg": 9630,
	"./dogodki/adventneDelavnice2015/velike/IMG-0029.jpg": 7675,
	"./dogodki/adventneDelavnice2015/velike/IMG-0033.jpg": 8610,
	"./dogodki/adventneDelavnice2015/velike/IMG-0039.jpg": 5720,
	"./dogodki/adventneDelavnice2015/velike/IMG-0040.jpg": 6304,
	"./dogodki/adventneDelavnice2015/velike/IMG-0041.jpg": 1869,
	"./dogodki/adventneDelavnice2015/velike/IMG-0043.jpg": 2943,
	"./dogodki/adventneDelavnice2015/velike/IMG-0044.jpg": 6564,
	"./dogodki/adventneDelavnice2015/velike/IMG-0045.jpg": 4609,
	"./dogodki/adventneDelavnice2015/velike/IMG-0054.jpg": 8355,
	"./dogodki/adventneDelavnice2015/velike/IMG-0055.jpg": 8870,
	"./dogodki/adventneDelavnice2015/velike/IMG-0056.jpg": 6625,
	"./dogodki/adventneDelavnice2015/velike/IMG-0057.jpg": 2292,
	"./dogodki/adventneDelavnice2015/velike/IMG-0060.jpg": 6506,
	"./dogodki/adventneDelavnice2015/velike/IMG-0062.jpg": 1944,
	"./dogodki/adventneDelavnice2015/velike/IMG-0067.jpg": 7193,
	"./dogodki/izlet2018/male/IMG_0686.jpeg": 6399,
	"./dogodki/izlet2018/male/IMG_0687.jpg": 8927,
	"./dogodki/izlet2018/male/IMG_0688.jpeg": 7653,
	"./dogodki/izlet2018/male/IMG_0689.jpeg": 7390,
	"./dogodki/izlet2018/male/IMG_0690.jpeg": 4444,
	"./dogodki/izlet2018/male/IMG_0691.jpeg": 9747,
	"./dogodki/izlet2018/male/IMG_0692.jpeg": 182,
	"./dogodki/izlet2018/male/IMG_0693.jpeg": 4045,
	"./dogodki/izlet2018/male/IMG_0694.jpeg": 6904,
	"./dogodki/izlet2018/male/IMG_0695.jpeg": 7391,
	"./dogodki/izlet2018/male/IMG_0696.jpeg": 242,
	"./dogodki/izlet2018/male/IMG_0697.jpeg": 5465,
	"./dogodki/izlet2018/male/IMG_0698.jpeg": 1124,
	"./dogodki/izlet2018/male/IMG_0699.jpeg": 2283,
	"./dogodki/izlet2018/male/IMG_0700.jpeg": 502,
	"./dogodki/izlet2018/male/IMG_0701.jpeg": 5469,
	"./dogodki/izlet2018/male/IMG_0702.jpeg": 7180,
	"./dogodki/izlet2018/male/IMG_0703.jpeg": 2435,
	"./dogodki/izlet2018/male/IMG_0704.jpeg": 8338,
	"./dogodki/izlet2018/male/IMG_0705.jpeg": 2345,
	"./dogodki/izlet2018/male/IMG_0706.jpeg": 7736,
	"./dogodki/izlet2018/male/IMG_0707.jpeg": 6255,
	"./dogodki/izlet2018/male/IMG_0708.jpeg": 1438,
	"./dogodki/izlet2018/male/IMG_0709.jpeg": 9749,
	"./dogodki/izlet2018/male/IMG_0710.jpeg": 3047,
	"./dogodki/izlet2018/male/IMG_0711.jpeg": 7264,
	"./dogodki/izlet2018/male/IMG_0712.jpeg": 6990,
	"./dogodki/izlet2018/male/IMG_0713.jpeg": 1114,
	"./dogodki/izlet2018/male/IMG_0714.jpeg": 923,
	"./dogodki/izlet2018/male/IMG_0715.jpeg": 9764,
	"./dogodki/izlet2018/male/IMG_0716.jpeg": 5701,
	"./dogodki/izlet2018/male/IMG_0717.jpeg": 3214,
	"./dogodki/izlet2018/male/IMG_0718.jpeg": 6031,
	"./dogodki/izlet2018/male/IMG_0719.jpeg": 5544,
	"./dogodki/izlet2018/male/IMG_0720.jpeg": 9803,
	"./dogodki/izlet2018/male/IMG_0721.jpeg": 9775,
	"./dogodki/izlet2018/male/IMG_0722.jpeg": 9186,
	"./dogodki/izlet2018/male/IMG_0723.jpeg": 921,
	"./dogodki/izlet2018/male/IMG_0724.jpeg": 4924,
	"./dogodki/izlet2018/male/IMG_0725.jpeg": 2659,
	"./dogodki/izlet2018/male/IMG_0726.jpeg": 7801,
	"./dogodki/izlet2018/male/IMG_0727.jpeg": 4797,
	"./dogodki/izlet2018/male/IMG_0728.jpeg": 6352,
	"./dogodki/izlet2018/male/IMG_0729.jpeg": 1879,
	"./dogodki/izlet2018/male/IMG_0730.jpeg": 7609,
	"./dogodki/izlet2018/male/IMG_0731.jpeg": 3330,
	"./dogodki/izlet2018/male/IMG_0732.jpeg": 1759,
	"./dogodki/izlet2018/velike/IMG_0686.jpeg": 3982,
	"./dogodki/izlet2018/velike/IMG_0687.jpg": 7644,
	"./dogodki/izlet2018/velike/IMG_0688.jpeg": 8552,
	"./dogodki/izlet2018/velike/IMG_0689.jpeg": 95,
	"./dogodki/izlet2018/velike/IMG_0690.jpeg": 8369,
	"./dogodki/izlet2018/velike/IMG_0691.jpeg": 5530,
	"./dogodki/izlet2018/velike/IMG_0692.jpeg": 7783,
	"./dogodki/izlet2018/velike/IMG_0693.jpeg": 6720,
	"./dogodki/izlet2018/velike/IMG_0694.jpeg": 8085,
	"./dogodki/izlet2018/velike/IMG_0695.jpeg": 9774,
	"./dogodki/izlet2018/velike/IMG_0696.jpeg": 43,
	"./dogodki/izlet2018/velike/IMG_0697.jpeg": 3012,
	"./dogodki/izlet2018/velike/IMG_0698.jpeg": 681,
	"./dogodki/izlet2018/velike/IMG_0699.jpeg": 6674,
	"./dogodki/izlet2018/velike/IMG_0700.jpeg": 4663,
	"./dogodki/izlet2018/velike/IMG_0701.jpeg": 9136,
	"./dogodki/izlet2018/velike/IMG_0702.jpeg": 17,
	"./dogodki/izlet2018/velike/IMG_0703.jpeg": 3322,
	"./dogodki/izlet2018/velike/IMG_0704.jpeg": 9899,
	"./dogodki/izlet2018/velike/IMG_0705.jpeg": 1380,
	"./dogodki/izlet2018/velike/IMG_0706.jpeg": 9941,
	"./dogodki/izlet2018/velike/IMG_0707.jpeg": 6606,
	"./dogodki/izlet2018/velike/IMG_0708.jpeg": 8911,
	"./dogodki/izlet2018/velike/IMG_0709.jpeg": 4968,
	"./dogodki/izlet2018/velike/IMG_0710.jpeg": 6390,
	"./dogodki/izlet2018/velike/IMG_0711.jpeg": 3261,
	"./dogodki/izlet2018/velike/IMG_0712.jpeg": 6732,
	"./dogodki/izlet2018/velike/IMG_0713.jpeg": 9011,
	"./dogodki/izlet2018/velike/IMG_0714.jpeg": 6930,
	"./dogodki/izlet2018/velike/IMG_0715.jpeg": 9129,
	"./dogodki/izlet2018/velike/IMG_0716.jpeg": 3112,
	"./dogodki/izlet2018/velike/IMG_0717.jpeg": 527,
	"./dogodki/izlet2018/velike/IMG_0718.jpeg": 1886,
	"./dogodki/izlet2018/velike/IMG_0719.jpeg": 3269,
	"./dogodki/izlet2018/velike/IMG_0720.jpeg": 2937,
	"./dogodki/izlet2018/velike/IMG_0721.jpeg": 2610,
	"./dogodki/izlet2018/velike/IMG_0722.jpeg": 127,
	"./dogodki/izlet2018/velike/IMG_0723.jpeg": 1608,
	"./dogodki/izlet2018/velike/IMG_0724.jpeg": 9341,
	"./dogodki/izlet2018/velike/IMG_0725.jpeg": 4246,
	"./dogodki/izlet2018/velike/IMG_0726.jpeg": 8611,
	"./dogodki/izlet2018/velike/IMG_0727.jpeg": 1676,
	"./dogodki/izlet2018/velike/IMG_0728.jpeg": 6833,
	"./dogodki/izlet2018/velike/IMG_0729.jpeg": 7290,
	"./dogodki/izlet2018/velike/IMG_0730.jpeg": 3336,
	"./dogodki/izlet2018/velike/IMG_0731.jpeg": 7935,
	"./dogodki/izlet2018/velike/IMG_0732.jpeg": 626,
	"./dogodki/romanje2018/male/romanje2018_10.jpg": 3345,
	"./dogodki/romanje2018/male/romanje2018_11.jpg": 5300,
	"./dogodki/romanje2018/male/romanje2018_12.jpg": 6931,
	"./dogodki/romanje2018/male/romanje2018_13.jpg": 3766,
	"./dogodki/romanje2018/male/romanje2018_14.jpg": 5229,
	"./dogodki/romanje2018/male/romanje2018_15.jpg": 6000,
	"./dogodki/romanje2018/male/romanje2018_16.jpg": 9615,
	"./dogodki/romanje2018/male/romanje2018_17.jpg": 5330,
	"./dogodki/romanje2018/male/romanje2018_18.jpg": 4041,
	"./dogodki/romanje2018/male/romanje2018_19.jpg": 8668,
	"./dogodki/romanje2018/male/romanje2018_20.jpg": 1840,
	"./dogodki/romanje2018/male/romanje2018_21.jpg": 2765,
	"./dogodki/romanje2018/male/romanje2018_22.jpg": 9858,
	"./dogodki/romanje2018/male/romanje2018_23.jpg": 6175,
	"./dogodki/romanje2018/male/romanje2018_24.jpg": 5364,
	"./dogodki/romanje2018/male/romanje2018_25.jpg": 9089,
	"./dogodki/romanje2018/male/romanje2018_26.jpg": 1318,
	"./dogodki/romanje2018/male/romanje2018_27.jpg": 9843,
	"./dogodki/romanje2018/male/romanje2018_28.jpg": 9992,
	"./dogodki/romanje2018/male/romanje2018_29.jpg": 1173,
	"./dogodki/romanje2018/male/romanje2018_30.jpg": 6143,
	"./dogodki/romanje2018/male/romanje2018_31.jpg": 9762,
	"./dogodki/romanje2018/male/romanje2018_32.jpg": 7565,
	"./dogodki/romanje2018/male/romanje2018_33.jpg": 5824,
	"./dogodki/romanje2018/male/romanje2018_34.jpg": 5987,
	"./dogodki/romanje2018/male/romanje2018_35.jpg": 1222,
	"./dogodki/romanje2018/male/romanje2018_36.jpg": 3361,
	"./dogodki/romanje2018/male/romanje2018_37.jpg": 3412,
	"./dogodki/romanje2018/male/romanje2018_38.jpg": 8567,
	"./dogodki/romanje2018/male/romanje2018_39.jpg": 6634,
	"./dogodki/romanje2018/male/romanje2018_40.jpg": 1558,
	"./dogodki/romanje2018/male/romanje2018_41.jpg": 6323,
	"./dogodki/romanje2018/male/romanje2018_42.jpg": 3748,
	"./dogodki/romanje2018/male/romanje2018_43.jpg": 6078,
	"./dogodki/romanje2018/male/romanje2018_44.jpg": 98,
	"./dogodki/romanje2018/male/romanje2018_45.jpg": 6479,
	"./dogodki/romanje2018/male/romanje2018_46.jpg": 6160,
	"./dogodki/romanje2018/male/romanje2018_47.jpg": 7901,
	"./dogodki/romanje2018/male/romanje2018_48.jpg": 1310,
	"./dogodki/romanje2018/male/romanje2018_49.jpg": 1467,
	"./dogodki/romanje2018/male/romanje2018_50.jpg": 7805,
	"./dogodki/romanje2018/male/romanje2018_51.jpg": 2912,
	"./dogodki/romanje2018/male/romanje2018_52.jpg": 6639,
	"./dogodki/romanje2018/male/romanje2018_53.jpg": 8578,
	"./dogodki/romanje2018/male/romanje2018_54.jpg": 3809,
	"./dogodki/romanje2018/male/romanje2018_55.jpg": 2004,
	"./dogodki/romanje2018/male/romanje2018_56.jpg": 8067,
	"./dogodki/romanje2018/male/romanje2018_57.jpg": 7958,
	"./dogodki/romanje2018/male/romanje2018_58.jpg": 4773,
	"./dogodki/romanje2018/male/romanje2018_59.jpg": 456,
	"./dogodki/romanje2018/male/romanje2018_60.jpg": 9788,
	"./dogodki/romanje2018/male/romanje2018_61.jpg": 3513,
	"./dogodki/romanje2018/male/romanje2018_62.jpg": 1022,
	"./dogodki/romanje2018/male/romanje2018_63.jpg": 7483,
	"./dogodki/romanje2018/male/romanje2018_64.jpg": 1000,
	"./dogodki/romanje2018/male/romanje2018_65.jpg": 1909,
	"./dogodki/romanje2018/male/romanje2018_66.jpg": 922,
	"./dogodki/romanje2018/male/romanje2018_67.jpg": 3575,
	"./dogodki/romanje2018/male/romanje2018_68.jpg": 1924,
	"./dogodki/romanje2018/male/romanje2018_69.jpg": 449,
	"./dogodki/romanje2018/male/romanje2018_70.jpg": 2491,
	"./dogodki/romanje2018/male/romanje2018_71.jpg": 1182,
	"./dogodki/romanje2018/male/romanje2018_72.jpg": 7129,
	"./dogodki/romanje2018/male/romanje2018_73.jpg": 5516,
	"./dogodki/romanje2018/male/romanje2018_74.jpg": 1831,
	"./dogodki/romanje2018/male/romanje2018_75.jpg": 666,
	"./dogodki/romanje2018/male/romanje2018_76.jpg": 8517,
	"./dogodki/romanje2018/male/romanje2018_77.jpg": 904,
	"./dogodki/romanje2018/male/romanje2018_78.jpg": 3667,
	"./dogodki/romanje2018/male/romanje2018_79.jpg": 8406,
	"./dogodki/romanje2018/male/romanje2018_80.jpg": 290,
	"./dogodki/romanje2018/male/romanje2018_81.jpg": 9020,
	"./dogodki/romanje2018/male/romanje2018_82.jpg": 5328,
	"./dogodki/romanje2018/male/romanje2018_83.jpg": 8781,
	"./dogodki/romanje2018/male/romanje2018_84.jpg": 5430,
	"./dogodki/romanje2018/male/romanje2018_85.jpg": 6483,
	"./dogodki/romanje2018/velike/romanje2018_10.jpg": 8350,
	"./dogodki/romanje2018/velike/romanje2018_11.jpg": 6395,
	"./dogodki/romanje2018/velike/romanje2018_12.jpg": 8060,
	"./dogodki/romanje2018/velike/romanje2018_13.jpg": 9113,
	"./dogodki/romanje2018/velike/romanje2018_14.jpg": 8218,
	"./dogodki/romanje2018/velike/romanje2018_15.jpg": 407,
	"./dogodki/romanje2018/velike/romanje2018_16.jpg": 6600,
	"./dogodki/romanje2018/velike/romanje2018_17.jpg": 4469,
	"./dogodki/romanje2018/velike/romanje2018_18.jpg": 7926,
	"./dogodki/romanje2018/velike/romanje2018_19.jpg": 1059,
	"./dogodki/romanje2018/velike/romanje2018_20.jpg": 5283,
	"./dogodki/romanje2018/velike/romanje2018_21.jpg": 6870,
	"./dogodki/romanje2018/velike/romanje2018_22.jpg": 2657,
	"./dogodki/romanje2018/velike/romanje2018_23.jpg": 9060,
	"./dogodki/romanje2018/velike/romanje2018_24.jpg": 5439,
	"./dogodki/romanje2018/velike/romanje2018_25.jpg": 9058,
	"./dogodki/romanje2018/velike/romanje2018_26.jpg": 3213,
	"./dogodki/romanje2018/velike/romanje2018_27.jpg": 5120,
	"./dogodki/romanje2018/velike/romanje2018_28.jpg": 427,
	"./dogodki/romanje2018/velike/romanje2018_29.jpg": 270,
	"./dogodki/romanje2018/velike/romanje2018_30.jpg": 1012,
	"./dogodki/romanje2018/velike/romanje2018_31.jpg": 8385,
	"./dogodki/romanje2018/velike/romanje2018_32.jpg": 614,
	"./dogodki/romanje2018/velike/romanje2018_33.jpg": 9139,
	"./dogodki/romanje2018/velike/romanje2018_34.jpg": 5107,
	"./dogodki/romanje2018/velike/romanje2018_35.jpg": 8413,
	"./dogodki/romanje2018/velike/romanje2018_36.jpg": 9154,
	"./dogodki/romanje2018/velike/romanje2018_37.jpg": 1823,
	"./dogodki/romanje2018/velike/romanje2018_38.jpg": 4076,
	"./dogodki/romanje2018/velike/romanje2018_39.jpg": 2073,
	"./dogodki/romanje2018/velike/romanje2018_40.jpg": 2473,
	"./dogodki/romanje2018/velike/romanje2018_41.jpg": 5100,
	"./dogodki/romanje2018/velike/romanje2018_42.jpg": 2795,
	"./dogodki/romanje2018/velike/romanje2018_43.jpg": 6334,
	"./dogodki/romanje2018/velike/romanje2018_44.jpg": 7221,
	"./dogodki/romanje2018/velike/romanje2018_45.jpg": 9960,
	"./dogodki/romanje2018/velike/romanje2018_46.jpg": 8887,
	"./dogodki/romanje2018/velike/romanje2018_47.jpg": 9882,
	"./dogodki/romanje2018/velike/romanje2018_48.jpg": 9409,
	"./dogodki/romanje2018/velike/romanje2018_49.jpg": 884,
	"./dogodki/romanje2018/velike/romanje2018_50.jpg": 3890,
	"./dogodki/romanje2018/velike/romanje2018_51.jpg": 5599,
	"./dogodki/romanje2018/velike/romanje2018_52.jpg": 8224,
	"./dogodki/romanje2018/velike/romanje2018_53.jpg": 3117,
	"./dogodki/romanje2018/velike/romanje2018_54.jpg": 6918,
	"./dogodki/romanje2018/velike/romanje2018_55.jpg": 7027,
	"./dogodki/romanje2018/velike/romanje2018_56.jpg": 7316,
	"./dogodki/romanje2018/velike/romanje2018_57.jpg": 9121,
	"./dogodki/romanje2018/velike/romanje2018_58.jpg": 8010,
	"./dogodki/romanje2018/velike/romanje2018_59.jpg": 9399,
	"./dogodki/romanje2018/velike/romanje2018_60.jpg": 71,
	"./dogodki/romanje2018/velike/romanje2018_61.jpg": 7882,
	"./dogodki/romanje2018/velike/romanje2018_62.jpg": 4133,
	"./dogodki/romanje2018/velike/romanje2018_63.jpg": 6264,
	"./dogodki/romanje2018/velike/romanje2018_64.jpg": 6059,
	"./dogodki/romanje2018/velike/romanje2018_65.jpg": 1662,
	"./dogodki/romanje2018/velike/romanje2018_66.jpg": 8777,
	"./dogodki/romanje2018/velike/romanje2018_67.jpg": 7724,
	"./dogodki/romanje2018/velike/romanje2018_68.jpg": 2447,
	"./dogodki/romanje2018/velike/romanje2018_69.jpg": 738,
	"./dogodki/romanje2018/velike/romanje2018_70.jpg": 9864,
	"./dogodki/romanje2018/velike/romanje2018_71.jpg": 3829,
	"./dogodki/romanje2018/velike/romanje2018_72.jpg": 9626,
	"./dogodki/romanje2018/velike/romanje2018_73.jpg": 7143,
	"./dogodki/romanje2018/velike/romanje2018_74.jpg": 828,
	"./dogodki/romanje2018/velike/romanje2018_75.jpg": 6089,
	"./dogodki/romanje2018/velike/romanje2018_76.jpg": 6494,
	"./dogodki/romanje2018/velike/romanje2018_77.jpg": 7803,
	"./dogodki/romanje2018/velike/romanje2018_78.jpg": 8672,
	"./dogodki/romanje2018/velike/romanje2018_79.jpg": 4237,
	"./dogodki/romanje2018/velike/romanje2018_80.jpg": 8077,
	"./dogodki/romanje2018/velike/romanje2018_81.jpg": 7152,
	"./dogodki/romanje2018/velike/romanje2018_82.jpg": 1487,
	"./dogodki/romanje2018/velike/romanje2018_83.jpg": 8818,
	"./dogodki/romanje2018/velike/romanje2018_84.jpg": 8049,
	"./dogodki/romanje2018/velike/romanje2018_85.jpg": 676,
	"./dogodki/sprejem2017/male/IMAG3601.jpg": 2543,
	"./dogodki/sprejem2017/male/IMAG3602.jpg": 4544,
	"./dogodki/sprejem2017/male/IMAG3603.jpg": 6765,
	"./dogodki/sprejem2017/male/IMAG3604.jpg": 7686,
	"./dogodki/sprejem2017/male/IMAG3605.jpg": 819,
	"./dogodki/sprejem2017/male/IMAG3606.jpg": 4756,
	"./dogodki/sprejem2017/male/IMAG3607.jpg": 5441,
	"./dogodki/sprejem2017/male/IMAG3608.jpg": 7978,
	"./dogodki/sprejem2017/velike/IMAG3601.jpg": 1224,
	"./dogodki/sprejem2017/velike/IMAG3602.jpg": 8679,
	"./dogodki/sprejem2017/velike/IMAG3603.jpg": 2842,
	"./dogodki/sprejem2017/velike/IMAG3604.jpg": 3737,
	"./dogodki/sprejem2017/velike/IMAG3605.jpg": 2684,
	"./dogodki/sprejem2017/velike/IMAG3606.jpg": 4667,
	"./dogodki/sprejem2017/velike/IMAG3607.jpg": 6622,
	"./dogodki/sprejem2017/velike/IMAG3608.jpg": 1629,
	"./izlet2018.jpg": 8231,
	"./romanje2018.jpg": 6899,
	"./sprejem2017.jpg": 7182,
	"./tunjice.jpg": 8944,
	"./tunjice/male/cerkev-sv.-ane-tunjice-104-avtor-Matjaz-Sedusak.jpg": 5839,
	"./tunjice/male/cerkev-sv.-ane-tunjice-98-avtor-Matjaz-Sedusak.jpg": 4559,
	"./tunjice/male/internet-1-avtor-Matjaz-Sedusak.jpg": 8566,
	"./tunjice/male/internet-11-avtor-Matjaz-Sedusak.jpg": 767,
	"./tunjice/male/internet-12-avtor-Matjaz-Sedusak.jpg": 9846,
	"./tunjice/male/internet-13-avtor-Matjaz-Sedusak.jpg": 5941,
	"./tunjice/male/internet-2-avtor-Matjaz-Sedusak.jpg": 5615,
	"./tunjice/male/internet-20-avtor-Matjaz-Sedusak.jpg": 1392,
	"./tunjice/male/internet-21-avtor-Matjaz-Sedusak.jpg": 3564,
	"./tunjice/male/internet-5-avtor-Matjaz-Sedusak.jpg": 3658,
	"./tunjice/male/internet-6-avtor-Matjaz-Sedusak.jpg": 9619,
	"./tunjice/male/internet-7-avtor-Matjaz-Sedusak.jpg": 524,
	"./tunjice/male/megla-ivje-6-avtor-Matjaz-Sedusak.jpg": 3919,
	"./tunjice/velike/cerkev-sv.-ane-tunjice-104.jpg": 3758,
	"./tunjice/velike/cerkev-sv.-ane-tunjice-98.jpg": 2048,
	"./tunjice/velike/internet-1.jpg": 8669,
	"./tunjice/velike/internet-11.jpg": 7572,
	"./tunjice/velike/internet-12.jpg": 1267,
	"./tunjice/velike/internet-13.jpg": 6006,
	"./tunjice/velike/internet-2.jpg": 178,
	"./tunjice/velike/internet-20.jpg": 6736,
	"./tunjice/velike/internet-21.jpg": 8957,
	"./tunjice/velike/internet-5.jpg": 3089,
	"./tunjice/velike/internet-6.jpg": 5318,
	"./tunjice/velike/internet-7.jpg": 6371,
	"./tunjice/velike/megla-ivje-6.jpg": 7046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9708;